<template>
  <div>
    <!-- #region 廣告類型-彈窗 -->
    <v-dialog
      v-model="categoryDialog.show"
      scrollable
      width="500px"
      @click:outside="CloseCategoryDialog()"
    >
      <v-card>
        <!-- header -->
        <v-card-title class="px-4">
          <div>
            {{ categoryDialog.title }}
          </div>
          <v-spacer></v-spacer>
          <v-btn icon @click="CloseCategoryDialog()">
            <v-icon>mdi-close</v-icon></v-btn
          >
        </v-card-title>
        <!-- body -->
        <v-card-text style="height: 400px" class="pa-0">
          <div v-for="x in categoryDialog.datas" :key="x.id">
            <v-checkbox
              v-model="categoryDialog.temporarySelected"
              :label="x.name"
              :value="x.id"
              class="mx-4 my-3 py-0"
              hide-details
            ></v-checkbox>
            <v-divider />
          </div>
        </v-card-text>

        <!-- footer -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="" text @click="categoryDialog.temporarySelected = []">
            {{ categoryDialog.clear }}
          </v-btn>
          <v-btn color="primary" @click="ConfirmCategorySelected()">
            {{ categoryDialog.confirm }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- #endregion -->
  </div>
</template>

<script>
import { Advertise_Get_Category } from "@/apis/api";

export default {
  props: {
    open: Boolean,
  },
  data() {
    return {
      categoryDialog: {
        show: false,
        title: "廣告類型",
        clear: "清除",
        confirm: "確定",
        datas: [],
        selected: [],
        temporarySelected: [],
      },
    };
  },
  watch: {
    open() {
      if (this.open) this.OpenCategoryDialog();
    },
  },
  mounted() {
    this.Advertise_Get_CategoryApi();
  },

  methods: {
    //#region Get廣告類別 API
    Advertise_Get_CategoryApi() {
      Advertise_Get_Category()
        .then((res) => {
          this.categoryDialog.datas = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //#endregion
    //#region 開啟廣告類型彈窗
    OpenCategoryDialog() {
      this.categoryDialog.temporarySelected = this.categoryDialog.selected;
      this.categoryDialog.show = true;
    },
    //#endregion

    // #region 關閉廣告類型彈窗
    CloseCategoryDialog() {
      this.categoryDialog.show = false;
      this.$emit("close", true);
    },
    //#endregion

    //#region 確認選擇廣告類型
    ConfirmCategorySelected() {
      this.categoryDialog.selected = this.categoryDialog.temporarySelected;
      this.categoryDialog.show = false;
      this.$emit("list", this.categoryDialog.selected);
      this.$emit("formatList", this.categorySelectedFormat());
    },
    //#endregion

    //#region 廣告類型 Format
    categorySelectedFormat() {
      let format = [];
      this.categoryDialog.selected.forEach((x) => {
        this.categoryDialog.datas.forEach((y) => {
          if (y.id === x) format.push(y.name);
        });
      });
      return format;
    },
    //#endregion
  },
};
</script>

<style scoped></style>
